import { render } from "./PhraseTags.vue?vue&type=template&id=1941faa8"
import script from "./PhraseTags.vue?vue&type=script&lang=js"
export * from "./PhraseTags.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__